import React, { FC, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ClickOutside } from '../clickoutside';
import {
    CloseIcon,
    Content,
    ModalPortal,
    ActionArea,
    ContentModal,
    DefaultHeader,
} from './styles';
import { ModalConfirmTyping } from './modal-confirm-typing';

export interface ModalProps {
    opened: boolean;
    position?: ModalPosition;
    onClickOutSide: (event?: any) => void;
    width?: string;
    height?: string;
    style?: React.CSSProperties;
    header?: FC<any>;
    title?: string;
    className?: string;
}


export enum ModalPosition {
    center = 'center',
    topCenter = 'topCenter',
    fullRight = 'fullRight',
    fullLeft = 'fullLeft',
}

const body = document.getElementsByTagName('body')?.[0];
const root = document.createElement('div');

if (!!root) {
    root.id = 'modal-portal';
}

export interface IModalPortal {
    width?: string;
    height?: string;
    position?: ModalPosition;
}

const Modal: FC<ModalProps> = ({
    opened,
    children,
    position,
    onClickOutSide,
    width,
    height,
    header,
    title,
    ...rest
}) => {
    useEffect(() => {
        !!body && !!root && opened && body.appendChild(root);

        return () => {
            !!body && !!root && opened && body?.removeChild(root);
        };
    }, [opened]);

    const Header = header as FC<any>;

    return ReactDOM.createPortal(
        <Content>
            <ClickOutside onClickOutside={onClickOutSide}>
                <ModalPortal
                    className={`modal ${rest.className}`}
                    width={width}
                    height={height}
                    position={position}
                >
                    <ActionArea withHeader={!!header} className='modal-header'>
                        {header ? (
                            <Header />
                        ) : (
                            <DefaultHeader>
                                <span>{title}</span>
                                <CloseIcon onClick={onClickOutSide} />
                            </DefaultHeader>
                        )}
                    </ActionArea>
                    <ContentModal className='modal-content'>{children}</ContentModal>
                </ModalPortal>
            </ClickOutside>
        </Content>,
        root,
        'modal-portal'
    );
};

export { Modal, ModalConfirmTyping };
